<template>
  <div class="flexbox-container">
    <div class="md-layout md-alignment-top-center">
      <div class="md-layout-item md-size-95">
          <p class="finish-message">無事入力が完了しました</p>
          <button class="btn btn-lg btn-primary btn-block" v-on:click="back">冷蔵庫ID入力に戻る</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Finish',
    created() {
      this.$parent.title = '入力完了';
      this.$parent.imageName = '';
      this.$parent.showMaintenanceInformation = false;
      this.$parent.hasMaintenancne = false;
    },
    methods: {
      back() {
        this.$router.push({ name: 'SelectBox' });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .finish-message {
    font-size: 3rem;
    margin-bottom: 5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Finish.vue?396ec132